<template>
<div class="notifications" @click="showNotifications = !showNotifications">
  <img class="bell" src="@/assets/bell.png"/>
    <div class="container" v-for="Notification in allNotifications" 
      :key="Notification.id" @click="markAsRead(Notification.id)">
        <div class="unread" v-if="Notification.readDate === null"></div>
        <div class="layout" v-show="showNotifications">
          <span class="title">{{ $t('common.notificationHeader') }}</span>
          <div class="notis" v-for="Notification in allNotifications" :key="Notification.id">
            <span class="notisTitle" @click="pushToProfile(Notification.reference, Notification.type)">
                {{Notification.type.description}}
            </span> <br>
            {{Notification.message}}<br>
            {{formattedDate(Notification.registerDate.date)}} <br>
            Prioritetsnivå: {{Notification.priority}}
          </div>
        </div>
    </div>
</div>
</template>

<script>
import { useStore } from 'vuex'
import {ref, onMounted } from 'vue'
import moment from 'moment'
import router from "@/router";
export default {
  name: 'NotificationsWidget',
  components: {  },

     setup(){
         const store = useStore()
         const allNotifications = ref()


        function pushToProfile(customerId){
            console.log("Sucessful load of new customer profile", customerId)
            if(Notification.reference > 0, Notification.type === 11){
            router.push({name:'Customer', params:{id:customerId}})
            }
          }

         onMounted(() => {
           allNotifications.value = store.getters.allNotifications

             store.dispatch('loadAllNotifications').then((res)=>{   
               console.log("Recived notifications", res)              
                 allNotifications.value = res
             }).catch((e)=>{
                 console.log('Unable to load notifications' + e.toString())
             })
            
         })

         return{
           allNotifications,
           pushToProfile
          }
      },

      methods:{
        formattedDate(date){
             return moment(date).format("DD/MM-YYYY")
         },

         markAsRead(id){
           console.log("mark as read", id)
             this.$store.dispatch('markNotificationsRead', id).then((res)=>{
               this.allNotifications.value = res
                 console.log("Sucessfull update call");
             }).catch(()=>{
                 console.log("Failed update call");
             })
         },
      },

      data: function() {
         return {
             showNotifications: false,
         }
     },
}
</script>

<style lang="css" scoped>
.container {
 position: fixed;
  left: 60px;
  right: 20px;
  top: 15px;
  text-align: left;
  display: flex;
  flex-flow: column;
  gap: 10px;
  z-index: 3000;
  width: 30px;
}
.notifications {
  position: fixed;
  left: 60px;
  right: 20px;
  top: 15px;
  text-align: left;
  display: flex;
  flex-flow: column;
  gap: 10px;
  z-index: 3000;
  width: 30px;
}
.bell{
  height: 30px;
  width: 30px;
  display: flex;
  cursor: pointer;
  opacity: 20%;
}
.displayNotification{
  position: fixed;
  left: 20px;
  top: 90px;
  width: 240px;
  text-align: left;
  display: flex;
}

.layout{
  width: 250px;
  height: 500px;
  position: fixed;
  flex-direction: column;
  left: 15px;
  top: 60px;
  display: flex;
  border: 2px solid rgba(204, 204, 204, 0.558);
  background-color: rgb(249, 249, 249);
  border-radius: 2%;
  overflow: scroll;
  font-family: Verdana, sans-serif;
}

.title{
  font-size: 19px;
  text-decoration: underline;
  text-decoration-thickness: 0,1px;
  text-decoration-color: rgba(0, 0, 0, 0.35);
  position: fixed;
  left: 70px;
}

.notis{
  width: 200px;
  height: 100px;
  display: flex;
  flex-direction: column;
  font-family:Verdana, sans-serif;
  font-size: 0.6em;
  position: relative;
  left: 20px;
  top: 10px;
  border-bottom: 1px solid rgb(219, 219, 219);
}

.notisTitle{
  width: 200px;
  height: 85px;
  display: flex;
  font-family: Verdana, sans-serif;
  font-weight: bold;
  position: relative;
  left: 0px;
  top: 30px;
  cursor: pointer;
}

.unread{
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: rgb(246, 3, 3);
  position: fixed;
  left: 75px;
  top: 15px;
  cursor: pointer;
}

@media screen and (max-width: 312px) {

  .notifications {
  position: fixed;
  left: 47px;
  right: 20px;
  top: 17px;
  text-align: left;
  display: flex;
  flex-flow: column;
  gap: 10px;
  z-index: 3000;
  width: 30px;
}

  .bell{
  height: 25px;
  width: 25px;
  display: flex;
  cursor: pointer;
  opacity: 30%;
}

.unread{
  width: 13px;
  height: 13px;
  position: fixed;
  left: 58px;
  top: 17px;
}
}
</style>
